
import './TransactionsHistoryModal.css';
import CloseModal from '../../CommonFunctions/closeModal';
import { useAtom } from 'jotai';
import { useDetailedOffer, useShowPopUpModal, useModalVersion, useModalInfo, useLoggedUser } from '../../../../data/GlobalStates';


const TransactionsHistoryModal = () => {


//stany globalne
 
    const [ ShowPopUpModal, setShowPopUpModal] = useAtom(useShowPopUpModal);
    const [ ModalVersion, setModalVersion] = useAtom(useModalVersion);
    const [ ModalInfo, setModalInfo] = useAtom(useModalInfo);
    const [ LoggedUser, setLoggedUser ] = useAtom(useLoggedUser);
  
const TranslatePackageTitle = (PackageType) => {
 if (PackageType == '3PremiumOffers') {
  return 'Pakiet 3 ofert premium'
 } else if (PackageType == '5PremiumOffers') {
  return 'Pakiet 5 ofert premium'
 } else if (PackageType == '10PremiumOffers') {
  return 'Pakiet 10 ofert premium'
 } else if (PackageType == '30PremiumOffers') {
  return 'Pakiet 30 ofert premium'
 } else if (PackageType == '50PremiumOffers') {
  return 'Pakiet 50 ofert premium'
 } else if (PackageType == 'BasicOffersLimitless') {
  return 'Pakiet ofert podstawowych'
 }
};

const PackageHistoryDisplayer = ({ data }) => {
  return (
    <div>
      {Object.entries(data).map(([year, months]) => (
        <div key={year}>
          <div className='HistoricPackagesYearHeader'>
            Rok: {year}
          </div>

          {Object.entries(months).map(([month, days]) => (
            <div key={month}>

              {Object.entries(days).map(([day, events]) => (
                <div key={day}>

                  {Object.values(events).map((ev) => (
                    <div className='PremiumPackagesHistoricValues' key={ev.id}>
                      <div className='HistoricValuesSmallDiv'>
                        <p className='HistoricValueHeader'>Pakiet: </p>
                        <p>{TranslatePackageTitle(ev.PackageType)}</p>
                      </div>
                      <div className='HistoricValuesSmallDiv'>
                        <p className='HistoricValueHeader'>Data: </p>
                        <p>{ev.date}</p>
                      </div>
                      <div className='HistoricValuesSmallDiv'>
                        <p className='HistoricValueHeader'>ID: </p>
                        <p>{ev.id}</p>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

const PremiumPackageHistoryUseDisplayer = ({ data }) => {
  return (
    <div>
      {Object.entries(data).map(([year, months]) => (
        <div key={year}>
          <div className="HistoricPackagesYearHeader">
            Rok: {year}
          </div>

          {Object.entries(months).map(([month, events]) => (
            <div key={month}>
              <div className="HistoricPackagesMonthHeader">
                Miesiąc: {month}
              </div>

              {/* EVENTS */}
              {Object.entries(events).map(([eventId, ev]) => (
                <div className='PremiumPackagesHistoricValues' key={eventId}>
                  <div className='HistoricValuesSmallDiv'>
                    <p className='HistoricValueHeader'>Tytuł:</p>
                    <p>{ev.title}</p>
                  </div>

                  <div className='HistoricValuesSmallDiv'>
                    <p className='HistoricValueHeader'>Kraj:</p>
                    <p>{ev.country}</p>
                  </div>

                  <div className='HistoricValuesSmallDiv'>
                    <p className='HistoricValueHeader'>ID:</p>
                    <p>{eventId}</p>
                  </div>

                  <div className='HistoricValuesSmallDiv'>
                    <p className='HistoricValueHeader'>Data:</p>
                    <p>{new Date(ev.date).toLocaleString()}</p>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};


    return (
     <div id='HistoricTransactionsMainContainer'>
       <h4>{ModalInfo.title}</h4>
       {
        LoggedUser.BasicOffersTopUps ? 
        <>
          <p className='AplicationCofirmationParagrafs'>Pakiety Podstawowe:</p>
          <PackageHistoryDisplayer data={LoggedUser.BasicOffersTopUps}/>
        </>
        :
           <p className='AplicationCofirmationParagrafs'>Brak zakupionych pakietów podstawowych</p>
       }
       {
        LoggedUser.PremiumOffersTopUps ? 
        <>
          <p className='AplicationCofirmationParagrafs'>Pakiety Premium:</p>
          <PackageHistoryDisplayer data={LoggedUser.PremiumOffersTopUps}/>
        </>
        :
        <p className='AplicationCofirmationParagrafs'>Brak zakupionych pakietów premium</p>
       }
       {
        LoggedUser.PremiumOffersUse ? 
        <>
          <h4>Użycie pakietów premium:</h4>
          <PremiumPackageHistoryUseDisplayer data={LoggedUser.PremiumOffersUse}/>
        </>
        :
        null
       }
             <div>
               <button className='AplyButtons' onClick={() => CloseModal(setShowPopUpModal, setModalVersion, setModalInfo)}>Zamknij</button>
             </div>
     </div>
    )
}

export default TransactionsHistoryModal;
